export default "__VITE_ASSET__CXEnncz3__"